import { animate, style, transition, trigger } from '@angular/animations';

export const Animations = [
  
  trigger('slideDown', [
    
    transition(':enter', [
      style({height: '0px'}),
      animate('0.1s', style({height: '*'}))
    ]),
    
    transition(':leave', [
      style({height: '*'}),
      animate('0.1s', style({height: 0}))
    ]),
  
  ]),

];
